import classNames from 'classnames';
import React from 'react';
import _ from 'underscore';

type Props = {
  className?: string,
  label?: string,
  small?: boolean,
  extraSmall?: boolean,
  selected?: boolean
};

class Spinner extends React.PureComponent<Props> {
  constructor (props: Props) {
    super(props);
  }

  renderLine (degrees: number, opacity: number): JSX.Element {
    const {
      small,
      extraSmall,
      selected
    } = this.props;

    const svgSize = (extraSmall ? 16 : (small ? 32 : 200));
    const halfSize = svgSize / 2;

    const path = (extraSmall ? 'M2 8 H5' : (small ? 'M6 16 H10' : 'M50 100 H69'));
    const strokeWidth = (extraSmall ? 1 : (small ? 2 : 7));

    const getTransformString = (angle: number) => {
      return 'rotate(' + angle + ' ' + halfSize + ' ' + halfSize + ')';
    };

    return (
      <path
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        transform={degrees > 0 ? getTransformString(degrees) : undefined}
        className={classNames({esko_spinner_path: !(small || extraSmall), esko_spinner_small_path: (small || extraSmall), selected: selected})}
        d={path}
        opacity={opacity + ''}
      />
    );
  }

  override render (): React.ReactNode {
    const { className, label, small, extraSmall } = this.props;

    const loadingLabel = label ? <span>{label}</span> : null;
    const svgSize = (extraSmall ? 16 : (small ? 32 : 200));
    const halfSize = svgSize / 2;

    const getRotationValues = () => {
      let values = [];

      for (let i = 0; i <= 360; i += 30) {
        values.push([i, halfSize, halfSize].join());
      }

      return values.join(';');
    };

    return (
      <div className={classNames(className, 'esko_spinner', {esko_horizontal: small || extraSmall})}>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          version='1.1'
          width={svgSize}
          height={svgSize}
          className={classNames({esko_spinner_margin: extraSmall})}
        >
          <g>
            {this.renderLine(0, 1.0)}
            {this.renderLine(30, 0.04)}
            {this.renderLine(60, 0.04 + 0.08)}
            {this.renderLine(90, 0.04 + 0.08 * 2)}
            {this.renderLine(120, 0.04 + 0.08 * 3)}
            {this.renderLine(150, 0.04 + 0.08 * 4)}
            {this.renderLine(180, 0.04 + 0.08 * 5)}
            {this.renderLine(210, 0.04 + 0.08 * 6)}
            {this.renderLine(240, 0.04 + 0.08 * 7)}
            {this.renderLine(270, 0.04 + 0.08 * 8)}
            {this.renderLine(300, 0.04 + 0.08 * 9)}
            {this.renderLine(330, 0.04 + 0.08 * 10)}
            <animateTransform
              attributeName='transform'
              attributeType='XML'
              type='rotate'
              begin='0s'
              dur='1s'
              repeatCount='indefinite'
              calcMode='discrete'
              keyTimes='0;.0833;.166;.25;.3333;.4166;.5;.5833;.6666;.75;.8333;.9166;1'
              values={getRotationValues()}
            />
          </g>
        </svg>
        {loadingLabel}
      </div>
    );
  }
}

export default Spinner;
